module.exports = __webpack_public_path__ + "assets/images/05-balloon_994aacc4724566d5c96fdd6e97886572.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/05-balloon.png
// module id = 176
// module chunks = 0